export var CloudAccountType;
(function (CloudAccountType) {
    CloudAccountType["AccountTypeUnspecified"] = "ACCOUNT_TYPE_UNSPECIFIED";
    CloudAccountType["Source"] = "Source";
    CloudAccountType["Scanning"] = "Scanning";
    CloudAccountType["Vault"] = "Vault";
    CloudAccountType["Restore"] = "Restore";
})(CloudAccountType || (CloudAccountType = {}));
